<template>
  <div>
    <el-row>
      <div style="padding: 10px 25px">
        <el-form ref="form" :model="form" :inline="true" style="padding: 10px">
          <el-form-item>
            <el-input
              v-model="form.package_no"
              placeholder="包裹号"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="form.packge_status"
              clearable
              placeholder="包裹状态"
            >
              <el-option
                v-for="item in SEARCH_OPTIONS.PACKGE_STATUS"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="form.check_status"
              placeholder="商家核对状态"
              clearable
            >
              <el-option
                v-for="item in SEARCH_OPTIONS.CHECK_STATUS"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="form.check_result"
              placeholder="有无差异"
              clearable
            >
              <el-option
                v-for="item in SEARCH_OPTIONS.CHECK_RESULT"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label-width="0">
            <el-button type="primary" @click="handleSearch"> 查询 </el-button>
          </el-form-item>
          <el-form-item label-width="0">
            <el-button type="success" @click="handleListExport"
              >导出列表
            </el-button>
          </el-form-item>
          <el-form-item label-width="0">
            <el-button type="success" @click="handleLogExport">
              导出打标日志
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-row>
    <el-row>
      <el-table
        :key="'table1'"
        v-loading="tableLoading"
        :data="listData"
        border
        max-height="400px"
      >
        <el-table-column
          fixed="left"
          prop="package_no"
          label="包裹号"
          align="center"
          width="150"
        >
          <template #default="{ row }">
            <div>{{ row.package_no }}</div>
            <div v-if="row.package_no === formProps.current_package_no">
              (当前包裹)
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="spr_create_time_txt"
          label="包裹生成时间"
          align="center"
          width="150"
        >
        </el-table-column>
        <el-table-column
          prop="packge_status_txt"
          label="包裹状态"
          align="center"
          width="150"
        >
        </el-table-column>
        <el-table-column
          prop="check_status_txt"
          label="商家核对状态"
          align="center"
          width="150"
        >
        </el-table-column>
        <el-table-column
          prop="check_result_txt"
          label="核对结果"
          align="center"
          width="120"
        >
        </el-table-column>
        <el-table-column
          prop="total_amount_received"
          label="一手总收货件数"
          align="center"
          width="120"
        >
        </el-table-column>
        <el-table-column
          prop="no_goods_nums"
          label="无数据件数（不含已入库）"
          align="center"
          width="120"
        >
        </el-table-column>
        <el-table-column
          prop="stock_num"
          label="一手已入库数（当前实时）"
          align="center"
          width="120"
        >
        </el-table-column>
        <el-table-column
          prop="num"
          label="商家配货数"
          align="center"
          width="120"
        >
        </el-table-column>
        <el-table-column
          prop="check_sku_num"
          width="150"
          label="差异SKU个数"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="check_goods_num" align="center">
          <div slot="header">
            <div>当前入库差异件数</div>
            <el-tooltip
              class="item"
              effect="dark"
              content="入库差异件数 = 一手已入库件数 - 商家配货件数"
              placement="top-start"
            >
              <i class="el-icon-question" />
            </el-tooltip>
          </div>
          <template #default="{ row }">
            <NumColorCell :num="row.check_goods_num || ''" />
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" fixed="right">
          <template #default="{ row }">
            <el-button type="text" @click="handleShowLog(row)"
              >查看打标日志</el-button
            >
            <el-button type="text" @click="handleShowNoDataGoods(row)"
              >查看无数据商品</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <el-table
        :key="'table2'"
        v-loading="tableLoading"
        :data="totalData"
        border
        :show-header="false"
      >
        <el-table-column prop="" label="" align="center" width="150">
          合计
        </el-table-column>
        <el-table-column prop="" label="" align="center" width="150">
        </el-table-column>
        <el-table-column prop="" label="" align="center" width="150">
        </el-table-column>
        <el-table-column prop="" label="" align="center" width="150">
        </el-table-column>
        <el-table-column prop="" label="" align="center" width="120">
        </el-table-column>
        <el-table-column
          prop="total_amount_received"
          label=""
          align="center"
          width="120"
        >
        </el-table-column>

        <el-table-column prop="no_goods_nums" align="center" width="120">
        </el-table-column>
        <el-table-column prop="stock_num" align="center" width="120">
        </el-table-column>
        <el-table-column prop="check_details_num" align="center" width="120">
        </el-table-column>
        <el-table-column prop="check_sku_num" width="150" align="center">
        </el-table-column>
        <el-table-column prop="feedback_num" align="center">
          <template #default="{ row }">
            <NumColorCell :num="row.feedback_num || ''" />
          </template>
        </el-table-column>
        <el-table-column prop="" align="center" fixed="right">
        </el-table-column>
      </el-table>
    </el-row>
  </div>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";
import NumColorCell from "@//pages/receiveGoods/StockVarianceProcess/components/NumColorCell.vue";

import {
  postDetailPackageList,
  postExporPackagetDaBiaoRecord,
} from "@/openapi/erp/supplyPackageCheckRecord.js";

const SEARCH_OPTIONS = {
  CHECK_STATUS: [
    {
      value: 1,
      label: "待核对",
    },
    {
      value: 2,
      label: "已核对",
    },
  ],
  CHECK_RESULT: [
    {
      value: 1,
      label: "有差异",
    },
    {
      value: 2,
      label: "无差异",
    },
  ],
  PACKGE_STATUS: [
    {
      value: 1,
      label: "待接收",
    },
    {
      value: 2,
      label: "已接收",
    },
    {
      value: 3,
      label: "已点货",
    },
  ],
};
const FETCH_TYPE_MAP = {
  exportList: "1",
  showList: "2",
};

export default {
  name: "InventoryByPackage",
  components: {
    NumColorCell,
  },
  props: {
    formProps: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      FETCH_TYPE_MAP,
      SEARCH_OPTIONS,
      tableLoading: false,
      form: {
        supply_id: this.formProps.supply_id || "",
        package_no: "",
        packge_status: "",
        check_status: "",
        check_result: "",
        package_time: this.formProps.package_time || "",
        current_package_no: this.formProps.current_package_no || "",
        package_type: this.formProps.package_type || "", // 包裹类型 "1"、大货 "2"、前置仓
      },
      listData: [],
      totalData: [],
    };
  },
  watch: {
    formProps: {
      immediate: true,
      deep: true,
      handler(newVal) {
        this.form.supply_id = newVal.supply_id || "";
        this.form.package_time = newVal.package_time || "";
        this.form.current_package_no = newVal.current_package_no || "";
        this.form.package_type = newVal.package_type || "";
        if (
          Boolean(this.form.supply_id) &&
          Boolean(this.form.package_time) &&
          Boolean(this.form.package_type) &&
          Boolean(this.form.current_package_no)
        ) {
          this.fetchData("showList");
        }
      },
    },
  },
  created() {
    // this.fetchData("showList");
  },
  methods: {
    async fetchData(fetchType) {
      try {
        if (fetchType === "exportList") {
          this.form.export = FETCH_TYPE_MAP[fetchType];
        } else {
          delete this.form.export;
        }
        const showLoading = fetchType === "showList";
        if (showLoading) {
          this.tableLoading = true;
        }
        const res = await postDetailPackageList(this.form);
        if (showLoading) {
          this.listData = res.list || [];
          this.totalData = [res.statics] || [];
          this.tableLoading = false;
        } else {
          window.open(apiBaseURL + res.file);
        }
      } catch (err) {
        console.log("postGetList err: ", err);
        this.tableLoading = false;
      }
    },
    handleSearch() {
      this.fetchData("showList");
    },
    handleListExport() {
      this.fetchData("exportList");
    },
    async handleLogExport() {
      const { supply_id: supplyId, package_time: packageTime } = this.form;
      const params = { supply_id: supplyId, package_time: packageTime };

      try {
        const res = await postExporPackagetDaBiaoRecord(params);
        window.open(apiBaseURL + res.file);
      } catch (err) {
        console.error("postExporPackagetDaBiaoRecord err: ", err);
      }
    },
    handleShowLog(row) {
      this.$router.push(
        `/home/storage/markingloglist?package_no=${row.package_no}`
      );
    },
    handleShowNoDataGoods(row) {
      const { package_type: packageType } = this.formProps;
      // 这里前置仓类类型的值是"2'，打标日志的前置仓类类型的值是"3"，所以这里需要判断一下
      const queryPackageType = packageType === "2" ? "3" : packageType;
      this.$router.push(
        `/home/nodatagoods/list?from_source=1&package_no=${row.package_no}&package_type=${queryPackageType}`
      );
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/pages/receiveGoods/StockVarianceProcess/components/InventoryByPackage.vue